import { axiosNTL } from '../../../services/axios';

const list = () => axiosNTL
	.get('/contentTag')
	.then((res: any) => Promise.resolve(res.responseObject));

export const contentTagsServices = {
	list,
};